import { createUseStyles } from 'react-jss';

export default createUseStyles({
  inputsGrid: {
    maxWidth: '960px',
    display: 'grid',
    gridTemplateColumns: '280px 1fr 1fr',
    gridTemplateRows: '240px 1fr',
    gridRowGap: '12px',
    gridColumnGap: '48px',
    marginBottom: '24px',
    marginLeft: '30px',

    '& > div:nth-of-type(2)': {
      gridColumn: '2 / 4',
    },
    '& > div:nth-of-type(3)': {
      gridColumn: '1 / 3',
    },
    '& > button': {
      gridColumn: '3 / 4',
      placeSelf: 'end',
    },

    '@media(max-width: 900px)': {
      display: 'initial',
      '& > div:nth-of-type(2)': {
        marginTop: '48px',
      },
      '& > div:nth-of-type(3)': {
        marginTop: '28px',
      },
      '& > button': {
        marginTop: '48px',
        marginBottom: '20px',
      },
    }
  },

  switchesGrid: {
    paddingTop: '24px',
    '@media(max-width: 900px)': {
      paddingTop: 0,
    }
  },

  images: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '300px',
    gridColumnGap: '32px',
    '@media(max-width: 900px)': {
      display: 'initial',
    },
  },

  options: {
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    gridTemplateRows: '32px repeat(4, 24px)',
    gridRowGap: '24px',
    gridAutoFlow: 'column',
  },

  optionsHeader: {
    fontWeight: '500',
    fontSize: '16px',
    color: '#102131',
    gridColumn: '1 / 3',
  },

  button: {
    width: '180px',
    '@media(max-width: 900px)': {
      width: '100%',
    }
  },
});
